<template lang="html">
  <section class="efficiency_classes">
    <div class="row">
      <div class="col-lg-12 grid-margin stretch-card">
        <div class="card">
          <b-collapse id="efficiency_classes_filters" class="mt-2 ml-4 mr-4">
            <b-card>
              <p class="card-text">Filters</p>
              <div class="row">
                <div class="col-lg-6 mb-2">
                  <div class="row align-items-center">
                    <label class="col-lg-4 mb-0">Country Id:</label>
                    <div class="col-lg-8">
                      <b-select v-model="selectedCountry">
                        <b-form-select-option :value="null">---</b-form-select-option>
                        <option v-for="country in countryList" :key="country.id" :value="country">
                          {{ country.id }} - {{ country.descEn }}
                        </option>
                      </b-select>
                    </div>
                  </div>
                </div>

                <div class="col-lg-6 mb-2">
                  <div class="row align-items-center">
                    <label class="col-lg-4 mb-0">Model Id:</label>
                    <div class="col-lg-8">
                      <input type="text" class="col-lg-12" v-model="modelIdFilter" placeholder="Model Id" maxlength="7"/>
                    </div>
                  </div>
                </div>

                <div class="col-lg-6 mb-2">
                  <div class="row align-items-center">
                    <label class="col-lg-4 mb-0">Model Year:</label>
                    <div class="col-lg-8">
                      <div class="row">
                        <div class="col-lg-2 pt-2">From</div>
                        <div class="col-lg-4">
                          <input type="text" class="col-lg-12" v-model="modelYearFromFilter" maxlength="4"/>
                        </div>

                        <div class="col-lg-2 pt-2">To</div>
                        <div class="col-lg-4">
                          <input type="text" class="col-lg-12" v-model="modelYearToFilter" maxlength="4"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-6 mb-2">
                  <div class="row align-items-center">
                    <label class="col-lg-4 mb-0">Model Code:</label>
                    <div class="col-lg-8">
                      <input type="text" class="col-lg-12" v-model="modelCodeFilter" placeholder="Model Code" maxlength="15"/>
                    </div>
                  </div>
                </div>
              </div>
              <b-button variant="primary" v-b-toggle.efficiency_classes_filters @click="search()"><i class="mdi mdi-magnify"></i>Search</b-button>
            </b-card>
          </b-collapse>

          <div class="col-lg-12 card-body row">
            <div class="col-lg-12">
              <h4 class="card-title">Efficiency Classes</h4>
            </div>

            <div class="col-lg-4">
              <div class="col-lg-12 row">
                <b-pagination
                  align="fill"
                  limit="6"
                  v-model="currentPage"
                  :total-rows="totalRowsResult"
                  :per-page="perPage"
                  first-text="<<"
                  prev-text="<"
                  next-text=">"
                  last-text=">>"
                  ellipsisText="..."
                  class="col-lg-10"
                ></b-pagination>
              </div>
            </div>

            <div class="col-lg-1">
              <b-form-select id="perPage-dd" v-model="perPage" class="col-lg-12">
                <b-form-select-option value="5">5</b-form-select-option>
                <b-form-select-option value="10">10</b-form-select-option>
                <b-form-select-option value="20">20</b-form-select-option>
                <b-form-select-option value="50">50</b-form-select-option>
                <b-form-select-option value="100">100</b-form-select-option>
              </b-form-select>
            </div>

            <div class="col-lg-7">
              <span class="float-right">
                <b-button variant="primary mr-1" v-b-toggle.efficiency_classes_filters><i class="mdi mdi-filter"></i></b-button>
                <b-button variant="primary mr-1" @click="refreshTable"><i class="mdi mdi-refresh"></i>Refresh Table</b-button>
                <b-button variant="primary mr-1" v-b-modal.modal-new-efficiency @click="btnNew"><i class="mdi mdi-plus"></i>New</b-button>
              </span>
            </div>

            <b-table ref="efficiency_classes_tab"
              id="table"
              striped
              hover
              responsive
              :items="items"
              :fields="fields"
              :per-page="perPage"
              :current-page="1"
              primary-key="rowKey"
              no-local-sorting
              no-provider-paging
              sort-icon-left
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
            >
              <template v-slot:cell(editButton)="data" lang="html">
                <b-button size="sm" style="max-width: 2.875rem;" variant="primary" v-b-modal.modal-edit @click="curItem=copyItem(data.item)">
                  <i class="mdi mdi-pencil"></i>
                </b-button>
              </template>

              <template v-slot:cell(copyButton)="data" lang="html">
                <b-button size="sm" style="max-width: 2.875rem;" variant="secondary" @click="copyToNew(data.item)">
                  <i class="mdi mdi-content-copy"></i>
                </b-button>
              </template>

              <template v-slot:cell(deleteButton)="data" lang="html">
                <b-button size="sm" style="max-width: 2.875rem;" variant="danger" @click="deleteItem(data.item)">
                  <i class="mdi mdi-delete"></i>
                </b-button>
              </template>
              <template v-slot:cell(updateDate)="data">
                {{ formatDate(data.item.updateDate) }}
              </template>
              
            </b-table>

            <b-modal id="modal-edit" title="Edit Efficiency Class" v-if="curItem" size="xl" header-bg-variant="primary" header-text-variant="light" centered>
              <b-container fluid>
                <b-row class="mb-2">
                  <div class="col-lg-4 row m-0">
                    <div class="col-lg-6 techdata-field-label">Country Id*:</div>
                      <b-form-select
                        class="col-lg-5"
                        v-model="curItem.countryId"
                        disabled
                      >
                        <b-form-select-option
                          v-for="country in countryList"
                          :key="country.id"
                          :value="country.id"
                        >
                          {{ country.id }} - {{ country.descEn }}
                        </b-form-select-option>
                      </b-form-select>
                  </div>

                  <div class="col-lg-4 row m-0">
                    <div class="col-lg-6 techdata-field-label">Model Id*:</div>
                    <input type="text" class="col-lg-5" v-model="curItem.modelId" maxlength="7" disabled/>
                  </div>

                  <div class="col-lg-4 row m-0">
                    <div class="col-lg-6 techdata-field-label">Model Code*:</div>
                    <input type="text" class="col-lg-5" v-model="curItem.modelCode" maxlength="15" disabled/>
                  </div>
                </b-row>

                <b-row class="mb-2">
                  <div class="col-lg-4 row m-0">
                    <div class="col-lg-6 techdata-field-label">Model Year*:</div>
                    <input type="text" class="col-lg-5" v-model="curItem.modelYear" maxlength="4"/>
                  </div>

                  <div class="col-lg-4 row m-0">
                    <div class="col-lg-6 techdata-field-label">Efficiency Class Letter:</div>
                    <input type="text" class="col-lg-5" v-model="curItem.ecClassLetter" maxlength="3"/>
                  </div>
                </b-row>

                <hr>

                <b-row v-for="triple in getFormFieldTriples()" :key="'edit-' + triple[0].key" class="mb-2">
                  <div v-for="field in triple" :key="'edit-field-' + field.key" class="col-lg-4 row m-0">
                    <div class="col-lg-6 techdata-field-label">{{ field.label }}:</div>
                    <input :type="field.type" class="col-lg-5" v-model="curItem[field.key]" :maxlength="field.maxLength" :max="field.max"/>
                  </div>
                </b-row>
              </b-container>
              <template v-slot:modal-footer="{ cancel }" lang="html">
                <fragment>
                  <b-button variant="secondary" @click="cancel()">Annulla</b-button>
                  <b-button variant="primary" @click="saveCurItem(curItem)">Salva</b-button>
                </fragment>
              </template>
            </b-modal>

            <b-modal id="modal-new-efficiency" title="New Efficiency Class" size="xl" header-bg-variant="primary" header-text-variant="light" centered>
              <b-container fluid>
                <b-row class="mb-2">
                  <div class="col-lg-4 row m-0">
                    <div class="col-lg-6 techdata-field-label">Country Id*:</div>
                      <b-form-select
                        class="col-lg-5"
                        v-model="newItem.countryId">

                        <b-form-select-option :value="null">
                          ---
                        </b-form-select-option>

                        <b-form-select-option
                          v-for="country in countryList"
                          :key="country.id"
                          :value="country.id">

                          {{ country.id }} - {{ country.descEn }}

                        </b-form-select-option>

                      </b-form-select>
                  </div>

                  <div class="col-lg-4 row m-0">
                    <div class="col-lg-6 techdata-field-label">Model Id*:</div>
                    <input type="text" class="col-lg-5" v-model="newItem.modelId" maxlength="7"/>
                  </div>

                  <div class="col-lg-4 row m-0">
                    <div class="col-lg-6 techdata-field-label">Model Code*:</div>
                    <input type="text" class="col-lg-5" v-model="newItem.modelCode" maxlength="15"/>
                  </div>
                </b-row>

                <b-row class="mb-2">
                  <div class="col-lg-4 row m-0">
                    <div class="col-lg-6 techdata-field-label">Model Year*:</div>
                    <input type="text" class="col-lg-5" v-model="newItem.modelYear" maxlength="4"/>
                  </div>

                  <div class="col-lg-4 row m-0">
                    <div class="col-lg-6 techdata-field-label">Efficiency Class Letter:</div>
                    <input type="text" class="col-lg-5" v-model="newItem.ecClassLetter" maxlength="3"/>
                  </div>
                </b-row>

                <hr>

                <b-row v-for="triple in getFormFieldTriples()" :key="'new-' + triple[0].key" class="mb-2">
                  <div v-for="field in triple" :key="'new-field-' + field.key" class="col-lg-4 row m-0">
                    <div class="col-lg-6 techdata-field-label">{{ field.label }}:</div>
                    <input :type="field.type" class="col-lg-5" v-model="newItem[field.key]" :maxlength="field.maxLength" :max="field.max"/>
                  </div>
                </b-row>
              </b-container>

              <template v-slot:modal-footer="{ cancel }" lang="html">
                <fragment>
                  <b-button variant="secondary" @click="cancel()">Annulla</b-button>
                  <b-button variant="primary" @click="createItem()">Salva</b-button>
                </fragment>
              </template>
            </b-modal>

          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style>
.efficiency_classes table td,
.efficiency_classes table th {
  text-align: left !important;
  vertical-align: top !important;
}
</style>

<script lang="js">
import { mapActions, mapGetters } from "vuex";

export default {
  name: 'efficiency_classes',
  methods: {
    buildPayload(item) {
      let payload = Object.assign({}, item);
      payload.id = {
        countryId: item.countryId,
        modelId: item.modelId
      };
      payload.country = {
        id: item.countryId
      };
      return payload;
    },
    copyItem(item) {
      return Object.assign({}, item);
    },
    copyToNew(item) {
      this.newItem = this.copyItem(item);

      delete this.newItem.id;
      delete this.newItem.insertDate;
      delete this.newItem.insertUser;
      delete this.newItem.updateDate;
      delete this.newItem.updateUser;
      delete this.newItem.datetime;

      this.copiedCountryId = item.countryId;
      this.copiedModelId = item.modelId;

      this.$bvModal.show("modal-new-efficiency");
    },
    deleteItem(item) {
      this.$bvModal.msgBoxConfirm('Vuoi veramente cancellare ' + item.countryId + '/' + item.modelId + '?', {
        title: 'Elimina',
        okVariant: 'danger',
        okTitle: 'Elimina',
        cancelTitle: 'Annulla',
        hideHeaderClose: false,
        centered: true
      }).then(value => {
        if (value) {
          this.setSpinnerStatus(true);
          this.axios
            .delete('/ccb/auth/fe/masterTechdataEfficiency/' + item.countryId + '/' + item.modelId, this.authHeader)
            .then(response => {
              this.$bvModal.msgBoxOk(response.data.message, {
                okVariant: 'success',
                hideHeaderClose: false,
                centered: true
              }).then(value => {
                this.refreshTable();
                this.curItem = null;
              })
            })
            .catch(error => {
              this.$bvModal.msgBoxOk(error.message, {
                okVariant: 'danger',
                hideHeaderClose: false,
                centered: true
              })
            }).finally(e => {
              this.setSpinnerStatus(false);
            })
        }
      })
    },
    saveCurItem(curItem) {
      let validationMessage = this.validateEfficiencyItem(curItem);
      if (validationMessage) {
        this.$bvModal.msgBoxOk(validationMessage, {
          okVariant: 'danger',
          hideHeaderClose: false,
          centered: true
        })
        return;
      }
      this.setSpinnerStatus(true);
      this.axios
        .put('/ccb/auth/fe/masterTechdataEfficiency/' + curItem.countryId + '/' + curItem.modelId, this.buildPayload(curItem), this.authHeader)
        .then(response => {
          this.$bvModal.msgBoxOk(response.data.message, {
            okVariant: 'success',
            hideHeaderClose: false,
            centered: true
          }).then(value => {
            this.refreshTable();
          })
        })
        .catch(error => {
          this.$bvModal.msgBoxOk(error.message, {
            okVariant: 'danger',
            hideHeaderClose: false,
            centered: true
          })
        }).finally(e => {
          this.setSpinnerStatus(false);
          this.$bvModal.hide('modal-edit');
        })
    },
    createItem() {
      if (this.copiedCountryId !== null
          && this.copiedModelId !== null
          && this.newItem.countryId == this.copiedCountryId
          && this.newItem.modelId == this.copiedModelId) {

        this.$bvModal.msgBoxOk(
          "To create a copy, you must change Country Id and Model Id before saving.",
          {
            okVariant: "warning",
            centered: true
          }
        );

        return;
      }
      let validationMessage = this.validateEfficiencyItem(this.newItem);
      if (validationMessage) {
        this.$bvModal.msgBoxOk(validationMessage, {
          okVariant: 'danger',
          hideHeaderClose: false,
          centered: true
        })
      } else {
        this.setSpinnerStatus(true);
        this.axios
          .post('/ccb/auth/fe/masterTechdataEfficiency', this.buildPayload(this.newItem), this.authHeader)
          .then(response => {
            this.$bvModal.msgBoxOk(response.data.message, {
              okVariant: 'success',
              hideHeaderClose: false,
              centered: true
            }).then(value => {
              this.refreshTable();
            })
          })
          .catch(error => {
            this.$bvModal.msgBoxOk(error.message, {
              okVariant: 'danger',
              hideHeaderClose: false,
              centered: true
            })
          }).finally(e => {
            this.setSpinnerStatus(false);
            this.$bvModal.hide('modal-new-efficiency');
          })
      }
    },
    search() {
      if (this.modelYearFromFilter && !/^\d{4}$/.test(this.modelYearFromFilter)) {
        this.$bvModal.msgBoxOk("Model Year From must be 4 digits", {
          okVariant: "danger",
          centered: true
        });
        return;
      }

      if (this.modelYearToFilter && !/^\d{4}$/.test(this.modelYearToFilter)) {
        this.$bvModal.msgBoxOk("Model Year To must be 4 digits", {
          okVariant: "danger",
          centered: true
        });
        return;
      }

      if (this.modelYearFromFilter &&
          this.modelYearToFilter &&
          Number(this.modelYearFromFilter) > Number(this.modelYearToFilter)) {

        this.$bvModal.msgBoxOk("Model Year From cannot be greater than Model Year To", {
          okVariant: "danger",
          centered: true
        });

        return;
      }
      this.setLastSearch(this.search);
      this.setSpinnerStatus(true);

      let params = {
        countryId: this.selectedCountry ? this.selectedCountry.id : null,
        modelId: this.modelIdFilter ? this.modelIdFilter : null,
        modelYearFrom: this.modelYearFromFilter ? this.modelYearFromFilter : null,
        modelYearTo: this.modelYearToFilter ? this.modelYearToFilter : null,
        modelCode: this.modelCodeFilter,
        page: this.currentPage - 1,
        size: this.perPage,
        sortBy: this.sortBy === 'modelId' ? 'id.modelId'
        : this.sortBy === 'countryId' ? 'id.countryId'
        : this.sortBy,
        sortDesc: this.sortDesc
      };

      this.axios
        .get('/ccb/auth/fe/masterTechdataEfficiency/allPaged', {
          params: params,
          ...this.authHeader
        })
        .then((response) => {
          this.itemsData = response.data.content.map(item => {
          return {
            ...item,
            rowKey: item.countryId + '-' + item.modelId
          };
        });
          this.totalRowsResult = response.data.totalElements;
        })
        .finally(e => {
          this.setSpinnerStatus(false);
        });
    },
    btnNew() {
      this.copiedCountryId = null;
      this.copiedModelId = null;
      this.newItem = {
        countryId: null,
        modelId: null,
        modelCode: null,
        modelYear: null,
        ecClassLetter: null
      };
    },
    refreshTable() {
      this.search();
    },
    ...mapActions([
      'setCurApp',
      'setSpinnerStatus',
      'setLastSearch'
    ]),
    getFormFieldTriples() {
      let triples = [];
      for (let i = 0; i < this.formFields.length; i += 3) {
        triples.push(this.formFields.slice(i, i + 3));
      }
      return triples;
    },
    validateEfficiencyItem(item) {
      if (item.countryId === null || item.countryId === undefined || item.countryId === ''
          || item.modelId === null || item.modelId === undefined || item.modelId === ''
          || item.modelYear === null || item.modelYear === undefined || item.modelYear === ''
          || !item.modelCode) {
        return "Inserisci tutti i campi obbligatori";
      }

      if (Number(item.modelYear) < 1000 || Number(item.modelYear) > 9999) {
        return "Model Year must be 4 digits";
      }

      if (item.modelCode.length > 15) {
        return "Model Code must be max 15 characters";
      }

      return null;
    },
    formatDate(value) {
      if (!value) {
        return '';
      }

      return new Date(value).toLocaleString('it-IT');
    },
    loadCountries() {
      this.axios
        .get('/ccb/auth/fe/country/listCountryView', this.authHeader)
        .then(response => {
          this.countryList = [
            {
              id: 0,
              descEn: "All Countries"
            },
            ...response.data
          ];
        });
    }
  },
  data () {
    return {
      totalRowsResult: 0,
      currentPage: 1,
      perPage: 10,
      sortBy: 'modelCode',
      sortDesc: false,
      curItem: null,
      newItem: {},
      copiedCountryId: null,
      copiedModelId: null,
      itemsData: [],
      countryList: [],
      selectedCountry: null,
      fields: [
        { key: 'countryId', label: 'Country Id', sortable: true },
        { key: 'modelId', label: 'Model Id', sortable: true },
        { key: 'modelYear', label: 'Model Year', sortable: true },
        { key: 'modelCode', label: 'Model Code', sortable: true },
        { key: 'ecClassLetter', label: 'Efficiency Class Letter', sortable: false },
        { key: 'updateDate', label: 'Update Date', sortable: true },
        { key: 'updateUser', label: 'Update User', sortable: true },
        { key: 'editButton', label: 'Edit', sortable: false },
        { key: 'copyButton', label: 'Copy', sortable: false },
        { key: 'deleteButton', label: 'Delete', sortable: false }
      ],
      formFields: [
        { key: 'trim', label: 'Trim', type: 'text', maxLength: 50 },
        { key: 'consCombinedL100km', label: 'Combined Consumption (l/100km)', type: 'text', maxLength: 20 },
        { key: 'consUrbanL100km', label: 'Urban Consumption (l/100km)', type: 'text', maxLength: 20 },
        { key: 'consExtraL100km', label: 'Extra Urban Consumption (l/100km)', type: 'text', maxLength: 20 },
        { key: 'consPetrolEqL100km', label: 'Petrol Equivalent Consumption (l/100km)', type: 'text', maxLength: 20 },
        { key: 'emisCombinedGkm', label: 'Combined Emissions (g/km)', type: 'text', maxLength: 20 },
        { key: 'emisTargetGkm', label: 'Target Emissions (g/km)', type: 'text', maxLength: 20 },
        { key: 'emisDerivCarbElGkm', label: 'Derived Carbon Electric Emissions (g/km)', type: 'text', maxLength: 20 }
      ],
      modelIdFilter: '',
      modelYearFromFilter: '',
      modelYearToFilter: '',
      modelCodeFilter: ''
    }
  },
  computed: {
    items () {
      return this.itemsData ? this.itemsData : [];
    },
    ...mapGetters([
      'authHeader',
      'getCurUser'
    ])
  },
  watch: {
    currentPage(newValue, oldValue) {
      this.refreshTable();
    },
    perPage(newValue, oldValue) {
      this.refreshTable();
    },
    sortBy(newValue, oldValue) {
      this.refreshTable();
    },
    sortDesc(newValue, oldValue) {
      this.refreshTable();
    }
  },
  mounted() {
    this.setCurApp('ccadm');
    this.loadCountries();
    this.search();
  }
}
</script>

<style scoped lang="scss">
@import "../../assets/scss/_variables.scss";
.collapse {
  border: 1px solid $gray-lightest;
  border-radius: 0.25rem;
}

::v-deep .modal-dialog {
  max-width: 1400px;
}
</style>